module.exports = __webpack_public_path__ + "static/media/Icon-suspension.6af3c05a.svg";